import {createApp} from "vue";
import App from "@/App.vue";
import router from "@/router";
window.$ = require("jquery");

createApp(App)
  .use(router)
  .mount("#app");
